export const DETAILS_NOTIFICATION_POSITION = '144px';

export const LIST_NOTIFICATION_POSITION = '190px';
